// extracted by mini-css-extract-plugin
module.exports = {"base":"LeadParagraph_base__fubqF","bodyText":"LeadParagraph_bodyText__WLjTx","magPrimaryTitleSml":"LeadParagraph_magPrimaryTitleSml__xfzMv"};